import { library } from "@fortawesome/fontawesome-svg-core"
import { fal } from "@fortawesome/pro-light-svg-icons"
import { far } from "@fortawesome/pro-regular-svg-icons"
import { fas } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
import Antd from "ant-design-vue"
import { httpsCallable } from "firebase/functions"
import { getDownloadURL, ref as firebaseRef, uploadBytes } from "firebase/storage"
import { createPinia } from "pinia"
import { createApp } from "vue"
import VueGoogleMaps from "vue-google-maps-community-fork"

import App from "@/App.vue"
import { i18n } from "@/i18n"
import { initSentry } from "@/init/sentry"

library.add(fas, fal, far)

export function createBootstrappedApp({
  router,
  firebaseApp,
  firebaseFunctions,
  database,
  fileStorage,
  antdThemeConfig,
  currentThemeName,
  switchTheme,
  tenantCompany,
  myUser,
  jobsServiceClient,
  tenantContext = {},
  hasPermission,
  firestoreFunctions,
  rootComponent = App
}) {
  const app = createApp(rootComponent)

  initSentry(app)

  app.component("font-awesome-icon", FontAwesomeIcon)
  app.use(router)
  app.use(createPinia())

  app.mixin({
    methods: {
      isAuthorized: (key, ...args) => hasPermission(myUser, key, ...args),
      uploadFile: async function (filePath, rawFile) {
        const storageReference = firebaseRef(fileStorage, filePath)
        await uploadBytes(storageReference, rawFile)
        return await getDownloadURL(storageReference)
      },
      firedata: firestoreFunctions.firedata,
      firehttp: function (functionName, data) {
        return httpsCallable(
          firebaseFunctions,
          functionName
        )({
          ...{ language: i18n.global.locale },
          ...data
        })
      },
      log: console.log,
      $tf: (key, fallbackKey, ...params) => {
        return i18n.global.te(key) ? i18n.global.t(key, params) : i18n.global.t(fallbackKey, params)
      }
    }
  })

  app.provide("firebase", firebaseApp)
  app.provide("database", database)
  app.provide("router", router)
  app.provide("fileStorage", fileStorage)
  app.provide("antdThemeConfig", antdThemeConfig)
  app.provide("currentThemeName", currentThemeName)
  app.provide("switchTheme", switchTheme)
  app.provide("tenant", tenantCompany)
  app.provide("currentUser", myUser)
  app.provide("currentCompany", tenantCompany)
  if (jobsServiceClient) {
    app.provide("JobsServiceClient", jobsServiceClient)
  }
  app.provide("tenantUser", tenantContext.tenantUser)
  app.provide("tenantCompanies", tenantContext.tenantCompanies)
  app.provide("selectedTenantId", tenantContext.selectedTenantId)
  app.provide("tenantSelectionState", tenantContext.tenantSelectionState)
  app.provide("resolveTenantSelection", tenantContext.resolveTenantSelection)
  app.provide("requestTenantSelection", tenantContext.requestTenantSelection)
  app.provide("switchTenant", tenantContext.switchTenant)

  app.use(Antd)
  app.use(i18n)
  app.use(VueGoogleMaps, {
    load: {
      key: process.env.VUE_APP_GOOGLE_MAPS_KEY,
      libraries: "places"
    }
  })

  return app
}
